import {GenericObject} from "./generic-object.model";
import {Order} from "./shop/order.model";
import {GenericSettlementItem} from "./generic-settlement-item.model";

/**
 * Model reprezentujący główne rozliczenie finansowe (Settlement) zamówienia.
 * Odpowiada za śledzenie statusu płatności od momentu inicjacji w bramce płatniczej (np. Przelewy24)
 * aż do ostatecznego zaksięgowania i rozdzielenia środków na poszczególne podmioty.
 * Rozszerza GenericObject (zapewne dziedzicząc standardowe pola jak UUID).
 */
export class OrderSettlement extends GenericObject {


  /** Identyfikator transakcji wygenerowany i zwrócony przez system Przelewy24.
   */
  public p24TransactionId: string;

  /** Wewnętrzny numer zamówienia w systemie Przelewy24.
   */
  public p24OrderId: number;

  /** Data i czas, w którym bramka Przelewy24 ostatecznie potwierdziła wpłynięcie środków od klienta.
   */
  public p24ConfirmationDate: string;

  /** Ogólny identyfikator dostawcy płatności.
   */
  public paymentGatewayId: string;


  /** Data wygenerowania obiektu rozliczenia w systemie.
   */
  public created: string;

  /** Całkowita kwota rozliczenia.
   */
  public amount: number;

  /** Flaga oznaczająca, czy całe rozliczenie zostało zakończone sukcesem.
   */
  public isSettled: boolean;

  /** Aktualny, tekstowy status rozliczenia.
   */
  public status: string;


  /** Główny obiekt zamówienia, którego dotyczy ta płatność.
   */
  public order: Order;

  /** Tablica szczegółowych pozycji rozliczeniowych.
   * Reprezentuje podział głównej kwoty (amount) na mniejsze pozycje.
   */
  public settlementItems: GenericSettlementItem[];

  constructor() {
    super();
  }
}
